function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { CssContainer, Container } from "../../components/container";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import Auth from "../../functions/authenticate";
import { Button } from "@progress/kendo-react-buttons";
import { Link } from "react-router-dom";
import { hasTenantFeature } from "../../functions/tenant-features";
import ServiceFactory from "../../service";
import { num } from "../email-automation/common";
import { money } from "../email-campaigns/api";
import { stalled } from "./index";
import { errText } from "../reports/common";
import StepTree from "./graph";
import { journeySvc, triggerText, nodeTitle, nodeById, triggerClause, capFirst, delayDuration, initials, statusWord, agoText } from "./common";

/*
 * Journey page (EMAIL_JOURNEYS_UX.md; Email redesign 2026-10-09 mockup Journey.dc.html):
 * a white top bar (back, name + status, "Starts when …", Pause/Resume, Edit, ···), four
 * tiles, the centred step map with per-step sent / opened / clicked and drop-off
 * (GET {id}/funnel), and a People panel ("where is this person and why"). Drafts and
 * paused journeys run the server validator so "why can't I turn it on" is on the page.
 */

// Enrollment list: server paged (GET {id}/enrollments?status=&q=&$top=&$skip=), 50 a page.
const PAGE = 50;
// [status, label, funnel totals key]. Statuses are the enrollment API's.
const ENR_FILTERS = [["", "All", "enrolled"], ["Active", "Still going", "active"], ["Completed", "Finished", "completed"], ["ExitedGoal", "Reached the goal", "exitedGoal"], ["ExitedOptOut", "Unsubscribed", "exitedOptOut"], ["Failed", "Couldn't send", "failed"]];

// Raw step ids and exit codes the engine stores; never shown as-is.
const REASONS = {
  "migrated-automation": "joined before this journey's last change",
  end: "",
  completed: "",
  complete: "",
  exit: "",
  finished: "",
  goal: "reached the goal",
  converted: "reached the goal",
  "goal-met": "reached the goal",
  goalmet: "reached the goal",
  optout: "unsubscribed",
  "opt-out": "unsubscribed",
  unsubscribed: "unsubscribed",
  archived: "the journey was archived",
  cancelled: "removed from the journey",
  canceled: "removed from the journey"
};
function reasonText(r) {
  const k = String(r || "").trim();
  if (!k) return "";
  const low = k.toLowerCase();
  if (low in REASONS) return REASONS[low];
  if (/^[a-z0-9_:-]+$/i.test(k) && !/\s/.test(k)) return ""; // an unknown raw code: say nothing rather than show an id
  return k.charAt(0).toLowerCase() + k.slice(1);
}
const shortDate = iso => {
  if (!iso) return "";
  const d = new Date(iso);
  return isFinite(d.getTime()) ? d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  }) : "";
};
class EmailJourneyDetailViewComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "outside", e => {
      if (this.state.menu && this.menuRef.current && !this.menuRef.current.contains(e.target)) this.setState({
        menu: false
      });
    });
    _defineProperty(this, "esc", e => {
      if (e.key === "Escape" && this.state.menu) this.setState({
        menu: false
      });
    });
    _defineProperty(this, "duplicate", async () => {
      const j = this.state.journey;
      if (!j || this.state.busy) return;
      this.setState({
        busy: true,
        writeError: null
      });
      try {
        const d = await journeySvc(`/${j.id}/duplicate`).postAsync({});
        const newId = d && (d.id != null ? d.id : d.journeyId);
        if (!newId) throw new window.Error("no id");
        this.props.history.push(`/Email/journeys/edit/${newId}`);
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          writeError: errText(e, "The journey could not be duplicated: try again.")
        });
      }
    });
    _defineProperty(this, "setStatus", async (next, shopifyPaused) => {
      const j = this.state.journey;
      if (!j || this.state.busy) return;
      this.setState({
        busy: true,
        writeError: null,
        confirmArchive: false,
        shopifyConfirm: false
      });
      try {
        await journeySvc(`/${j.id}/status`).putAsync(shopifyPaused ? {
          status: next,
          shopifyPaused: true
        } : {
          status: next
        });
        await this.load();
        if (!this._alive) return;
        const persisted = this.state.journey && this.state.journey.status || j.status;
        this.setState({
          busy: false,
          writeError: persisted === next ? null : `The status change didn't stick: the journey is still ${String(persisted).toLowerCase()}. Try again.`
        });
      } catch (e) {
        let msg = errText(e, "The status change failed: try again.");
        // The service client only keeps a body's `message`; the guard answers 409 {needsShopifyConfirm}, so key off the status.
        if (e && (e.statusCode === 409 || e.status === 409)) {
          if (this._alive) this.setState({
            busy: false,
            shopifyConfirm: true,
            writeError: null
          });
          return;
        }
        try {
          const b = JSON.parse(e.message);
          if (b && b.needsShopifyConfirm) {
            if (this._alive) this.setState({
              busy: false,
              shopifyConfirm: true,
              writeError: null
            });
            return;
          }
          if (Array.isArray(b.errors) && b.errors.length) {
            msg = "Can't activate yet:";
            this.setState({
              issues: b.errors
            });
          }
        } catch (x) {/* raw */}
        if (this._alive) this.setState({
          busy: false,
          writeError: msg
        });
      }
    });
    this.state = {
      journey: null,
      funnel: null,
      enrollments: [],
      enrCount: null,
      enrMore: false,
      enrLoading: false,
      enrStatus: "",
      enrQ: "",
      issues: null,
      audiences: [],
      error: false,
      busy: false,
      writeError: null,
      confirmArchive: false,
      shopifyConfirm: false,
      menu: false
    };
    this._alive = true;
    this.menuRef = /*#__PURE__*/React.createRef();
  }
  id() {
    return this.props.params.id;
  }
  async componentDidMount() {
    document.addEventListener("mousedown", this.outside);
    document.addEventListener("keydown", this.esc);
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    try {
      const AudSvc = ServiceFactory.getType("/audience", "audience");
      new AudSvc().getAsync().then(d => {
        const list = (Array.isArray(d) ? d : d && d.items || []).map(a => ({
          id: String(a.id),
          name: a.name || a.title || String(a.id)
        }));
        if (this._alive) this.setState({
          audiences: list
        });
      }).catch(() => {});
    } catch (e) {/* decoration */}
    await this.load();
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._enrTimer);
    document.removeEventListener("mousedown", this.outside);
    document.removeEventListener("keydown", this.esc);
  }

  // One page of enrollments for the current filter; append=true keeps what is shown and adds the next page.
  async loadEnrollments(append) {
    const {
      enrStatus,
      enrQ
    } = this.state;
    const skip = append ? this.state.enrollments.length : 0;
    const seq = this._enrSeq = (this._enrSeq || 0) + 1;
    this.setState({
      enrLoading: true
    });
    const qs = [];
    if (enrStatus) qs.push(`status=${encodeURIComponent(enrStatus)}`);
    if (enrQ) qs.push(`q=${encodeURIComponent(enrQ)}`);
    qs.push(`$top=${PAGE}`, `$skip=${skip}`);
    let page = null;
    try {
      page = await journeySvc(`/${this.id()}/enrollments?${qs.join("&")}`).getAsync();
    } catch (e) {
      page = null;
    }
    if (!this._alive || seq !== this._enrSeq) return;
    let list = page && page.enrollments || [];
    // Fail soft until the paged contract is deployed: an unpaged list comes back whole, so filter and page it here.
    const unpaged = page && page.count == null && list.length > PAGE;
    if (unpaged) {
      const q = enrQ.toLowerCase();
      list = list.filter(e => (!enrStatus || e.status === enrStatus) && (!q || `${e.name || ""} ${e.email || ""}`.toLowerCase().includes(q)));
    }
    const count = page && page.count != null ? Number(page.count) : unpaged ? list.length : null;
    if (unpaged) list = list.slice(skip, skip + PAGE);
    const enrollments = append ? this.state.enrollments.concat(list) : list;
    const enrMore = count != null ? enrollments.length < count : list.length >= PAGE;
    this.setState({
      enrollments,
      enrCount: count,
      enrMore,
      enrLoading: false
    });
  }
  setEnrFilter(patch) {
    this.setState(patch, () => {
      clearTimeout(this._enrTimer);
      this._enrTimer = setTimeout(() => this.loadEnrollments(false), patch.enrQ != null ? 300 : 0);
    });
  }
  async load() {
    try {
      const [journey, funnel] = await Promise.all([journeySvc(`/${this.id()}`).getAsync(), journeySvc(`/${this.id()}/funnel`).getAsync().catch(() => null)]);
      if (!this._alive) return;
      if (!journey) {
        this.setState({
          error: true
        });
        return;
      }
      this.setState({
        journey,
        funnel
      });
      this.loadEnrollments(false);
      if (journey.status !== "Running") {
        journeySvc(`/${this.id()}/validate`).postAsync({}).then(v => this._alive && this.setState({
          issues: v && v.valid === false ? v.errors || [] : []
        })).catch(() => {});
      }
    } catch (e) {
      if (this._alive) this.setState({
        error: true
      });
    }
  }
  // One plain line for where a person is: never a raw step id.
  personLine(e, graph, audiences) {
    const why = reasonText(e.exitReason);
    const node = nodeById(graph, e.currentNodeId);
    const stepRaw = String(e.currentNodeId || "").toLowerCase();
    // What they did with the emails (per-step opened/clicked from the enrollments endpoint).
    const ems = Array.isArray(e.emails) ? e.emails : [];
    const titleOf = id => {
      const nn = nodeById(graph, id);
      return nn ? `"${nodeTitle(nn, audiences)}"` : "an email";
    };
    const clickedOn = ems.filter(x => x.clicked);
    const openedOn = ems.filter(x => x.opened && !x.clicked);
    const did = clickedOn.length ? clickedOn.length === 1 ? `clicked ${titleOf(clickedOn[0].nodeId)}` : `clicked ${clickedOn.length} emails` : openedOn.length ? openedOn.length === 1 ? `opened ${titleOf(openedOn[0].nodeId)}` : `opened ${openedOn.length} emails` : ems.length ? ems.length === 1 ? "hasn't opened it" : `hasn't opened any of ${ems.length} emails` : "";
    const withWhy = lead => [lead, did, why].filter(Boolean).join(" · ");
    switch (e.status) {
      case "Active":
        {
          if (stepRaw === "migrated-automation") return "Still going · joined before this journey's last change";
          if (stepRaw === "end") return "Finishing up";
          if (!node) return e.wakeAt ? `Next step ${shortDate(e.wakeAt)}` : "Still going";
          if (node.type === "delay") {
            const d = delayDuration(node);
            return d ? `Waiting ${d} before the next email` : "Waiting before the next email";
          }
          if (node.type === "email") return `Getting "${nodeTitle(node, audiences)}" next`;
          if (node.type === "branch") return "About to take the next path";
          return "Still going";
        }
      case "Completed":
        return withWhy("Finished");
      case "ExitedGoal":
        return why && why !== "reached the goal" ? `Reached the goal · ${why}` : "Reached the goal";
      case "ExitedOptOut":
        return "Unsubscribed";
      case "Failed":
        return "Couldn't send to this address";
      case "Cancelled":
        return withWhy("Removed from the journey");
      default:
        return withWhy(capFirst(String(e.status || "").toLowerCase()) || "In the journey");
    }
  }
  render() {
    if (!hasTenantFeature("emailAutomation")) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Email Automation isn't set up for this workspace."));
    }
    const {
      journey: j,
      funnel,
      enrollments,
      enrCount,
      enrMore,
      enrLoading,
      enrStatus,
      enrQ,
      issues,
      audiences,
      error,
      busy,
      writeError,
      confirmArchive,
      menu
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, {
      message: "This journey could not be loaded."
    });
    if (!j) return /*#__PURE__*/React.createElement(Loader, null);
    const graph = j.graph && Array.isArray(j.graph.nodes) ? j.graph : {
      startNodeId: null,
      nodes: []
    };
    const totals = funnel && funnel.totals || {};
    const stats = {};
    (funnel && funnel.nodes || []).forEach(n => {
      stats[n.nodeId] = n;
    });
    const sender = j.senderConfig || {};
    const running = j.status === "Running";
    const canActivate = j.status !== "Archived" && !(issues && issues.length);
    const goal = j.goal || {};
    const goalText = goal.kind === "conversion" ? "any conversion" : goal.kind === "eventOccurred" ? `the event "${goal.eventName || "?"}"` : "";
    const settings = graph.settings || {};
    const tot = k => Number(totals[k] != null ? totals[k] : j[k]) || 0;
    const enrolled = tot("enrolled");
    const active = tot("active");
    const completed = tot("completed");
    const reached = tot("exitedGoal");
    const finished = completed + reached;
    const sent = Number(totals.sent) || 0;
    const engagement = funnel && funnel.engagement !== false;
    const opened = Number(totals.opened) || 0,
      clicked = Number(totals.clicked) || 0;
    const revenue = totals.revenue != null ? totals.revenue : j.revenue;
    const orders = totals.orders != null ? totals.orders : totals.conversions != null ? totals.conversions : j.conversions;
    const attribution = totals.attributionDays != null ? totals.attributionDays : j.attributionDays;
    const last7 = j.enrolledLast7d != null ? Number(j.enrolledLast7d) : totals.enrolledLast7d != null ? Number(totals.enrolledLast7d) : null;
    const tiles = [{
      l: "Joined",
      v: num(enrolled),
      s: last7 != null ? `${num(last7)} in the last 7 days` : j.lastEnrolledDate ? `last joined ${agoText(j.lastEnrolledDate)}` : enrolled ? "since it started" : "no one yet"
    }, {
      l: "Finished",
      v: num(finished),
      s: `${num(active)} still going${reached ? ` · ${num(reached)} reached the goal` : ""}`
    }, engagement && sent > 0 ? {
      l: "Opened or clicked",
      v: `${Math.round(Math.max(opened, clicked) / sent * 100)}%`,
      s: `${num(opened)} opened · ${num(clicked)} clicked`
    } : {
      l: "Opened or clicked",
      v: "None yet",
      s: funnel && funnel.engagement === false ? "open and click tracking isn't on yet" : "shows once emails go out"
    }, revenue != null ? {
      l: "Sales",
      v: money(revenue),
      s: `${orders != null ? `${num(orders)} order${Number(orders) === 1 ? "" : "s"} ` : "orders "}within ${attribution || 35} days of an email`
    } : {
      l: "Sales",
      v: "None yet",
      s: "orders placed after an email show here"
    }];
    const failed = Number(totals.failed) || 0;
    const optOut = Number(totals.exitedOptOut) || 0;
    const health = stalled(j);
    const statusBtn = confirmArchive ? null : running ? /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.setStatus("Paused")
    }, busy ? "Saving…" : "Pause") : j.status === "Archived" ? /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.setStatus("Draft"),
      title: "Moves the journey back to Drafts; nothing is deleted when archiving"
    }, busy ? "Saving…" : "Restore to drafts") : /*#__PURE__*/React.createElement(Button, {
      disabled: busy || !canActivate,
      onClick: () => this.setStatus("Running"),
      title: canActivate ? "" : "Fix the items listed below first"
    }, busy ? "Saving…" : j.status === "Paused" ? "Resume" : "Turn on");
    const menuItems = [{
      label: "Duplicate",
      title: "Copy this journey as a new draft",
      run: this.duplicate
    }, !running && j.status !== "Archived" ? {
      label: "Archive",
      danger: true,
      title: "Hide from the list; people already in it keep their place",
      run: () => this.setState({
        confirmArchive: true
      })
    } : null].filter(Boolean);
    const quiet = settings.quietStartHourUtc != null && settings.quietEndHourUtc != null ? `No emails ${settings.quietStartHourUtc}:00 to ${settings.quietEndHourUtc}:00 ${settings.quietTimezone || "UTC"}` : null;
    const rules = [goalText ? `Goal: ${goalText}` : null, quiet, `Up to ${settings.dailyEmailCap || 2} emails per person a day`, sender.fromName || sender.fromEmail ? `From ${sender.fromName || ""}${sender.fromEmail ? ` <${sender.fromEmail}>` : ""}` : null].filter(Boolean).join(" · ");
    const countFor = k => k ? Number(totals[k] != null ? totals[k] : j[k]) : null;
    const filterLabel = (ENR_FILTERS.find(([k]) => k === enrStatus) || [])[1];
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-view ejl-detail"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ejl-topbar"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/Email/journeys",
      className: "ejl-back",
      "aria-label": "Back to Journeys",
      title: "Back to Journeys"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M15 18l-6-6 6-6"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ejl-title"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("h1", null, j.name), /*#__PURE__*/React.createElement("span", {
      className: `ejl-status ${j.isTemplate ? "template" : String(j.status || "draft").toLowerCase()}`
    }, j.isTemplate ? "Template" : statusWord(j.status))), /*#__PURE__*/React.createElement("span", {
      className: "sub"
    }, "Starts when ", triggerClause(j), " \xB7 each person goes through once")), /*#__PURE__*/React.createElement("span", {
      className: "ejl-grow"
    }), confirmArchive ? /*#__PURE__*/React.createElement("span", {
      className: "ejl-confirm"
    }, /*#__PURE__*/React.createElement("span", null, "Archive this journey?"), /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.setState({
        confirmArchive: false
      })
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.setStatus("Archived"),
      className: "ejl-danger-btn"
    }, "Yes, archive")) : statusBtn, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: () => this.props.history.push(`/Email/journeys/edit/${j.id}`),
      title: running ? "Running journeys open read-only: pause from the editor to change steps" : "Edit"
    }, "Edit"), /*#__PURE__*/React.createElement("span", {
      className: "ejl-menu",
      ref: this.menuRef
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ejl-more lg",
      "aria-label": "More",
      "aria-haspopup": "menu",
      "aria-expanded": menu,
      onClick: () => this.setState({
        menu: !menu
      })
    }, "\xB7\xB7\xB7"), menu ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-menu-list",
      role: "menu"
    }, menuItems.map(it => /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      key: it.label,
      className: it.danger ? "danger" : "",
      title: it.title,
      disabled: busy,
      onClick: () => {
        this.setState({
          menu: false
        });
        it.run();
      }
    }, it.label))) : null)), /*#__PURE__*/React.createElement("div", {
      className: "ejl-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ejl-main"
    }, writeError ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger"
    }, writeError) : null, this.state.shopifyConfirm ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice warning"
    }, /*#__PURE__*/React.createElement("b", null, "Shopify Email already sends this automation."), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: "4px 0 8px"
      }
    }, "If both run, customers get two emails. Pause the matching automation in Shopify Email (Marketing \u203A Automations), then confirm here."), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8
      }
    }, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: busy,
      onClick: () => this.setStatus("Running", true)
    }, "I paused it in Shopify Email, turn this on"), /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.setState({
        shopifyConfirm: false
      })
    }, "Keep it a draft"))) : null, issues && issues.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice warning"
    }, /*#__PURE__*/React.createElement("b", null, "A few things to fix before this can run"), /*#__PURE__*/React.createElement("ul", {
      style: {
        margin: "4px 0 0",
        paddingLeft: 18
      }
    }, issues.map((x, i) => /*#__PURE__*/React.createElement("li", {
      key: i
    }, x)))) : null, health ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice warning ec-health"
    }, /*#__PURE__*/React.createElement("b", null, "No one has joined in 2 weeks"), " (last joined ", j.lastEnrolledDate ? agoText(j.lastEnrolledDate) : "never", "). The journey is running, but nobody has started it lately. Common reasons:", /*#__PURE__*/React.createElement("ul", {
      style: {
        margin: "4px 0 6px",
        paddingLeft: 18
      }
    }, /*#__PURE__*/React.createElement("li", null, "the start isn't happening: check that \"", triggerText(j), "\" still happens on your site and reaches your tracking"), /*#__PURE__*/React.createElement("li", null, "the audience settings leave no one in: an included audience that has gone quiet, or an excluded one that now covers everyone"), /*#__PURE__*/React.createElement("li", null, "people without an email address, or who unsubscribed, never join"), /*#__PURE__*/React.createElement("li", null, "each person goes through once: people who already went through don't join again")), /*#__PURE__*/React.createElement(Link, {
      to: `/Email/journeys/edit/${j.id}`
    }, "Check the start"), " and the audience in the editor.") : null, /*#__PURE__*/React.createElement("div", {
      className: "ejl-tiles"
    }, tiles.map(t => /*#__PURE__*/React.createElement("div", {
      key: t.l,
      className: "ejl-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "l"
    }, t.l), /*#__PURE__*/React.createElement("b", null, t.v), /*#__PURE__*/React.createElement("span", {
      className: "s"
    }, t.s)))), /*#__PURE__*/React.createElement("div", {
      className: "ejl-mapcard"
    }, /*#__PURE__*/React.createElement(StepTree, {
      graph: graph,
      audiences: audiences,
      stats: funnel ? stats : null,
      enrolled: enrolled,
      finished: funnel ? finished : null,
      engagement: funnel ? funnel.engagement : undefined,
      triggerLabel: capFirst(triggerClause(j))
    }), failed || optOut ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-mapfoot"
    }, [failed ? `${num(failed)} couldn't be sent to` : null, optOut ? `${num(optOut)} unsubscribed along the way` : null].filter(Boolean).join(" · ")) : null, funnel && funnel.engagement === false ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-mapfoot"
    }, "Open and click counts show up once tracking is turned on for your sending account.") : null, rules ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-mapfoot"
    }, rules) : null)), /*#__PURE__*/React.createElement("aside", {
      className: "ejl-people"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ejl-people-head"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("b", null, "People"), /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, enrCount != null ? num(enrCount) : enrolled ? num(enrolled) : "", enrStatus && filterLabel ? ` ${filterLabel.toLowerCase()}` : "")), /*#__PURE__*/React.createElement("div", {
      className: "ejl-pills sm"
    }, ENR_FILTERS.map(([k, l, tk]) => {
      const c = k ? countFor(tk) : null;
      if (k && (k === "Failed" || k === "ExitedGoal") && !c && enrStatus !== k) return null; // rare states only when they happen
      return /*#__PURE__*/React.createElement("button", {
        key: k || "all",
        type: "button",
        className: `ejl-pill${enrStatus === k ? " on" : ""}`,
        onClick: () => this.setEnrFilter({
          enrStatus: k
        })
      }, l, c != null ? ` ${num(c)}` : "");
    })), /*#__PURE__*/React.createElement("input", {
      className: "ejl-people-search",
      value: enrQ,
      onChange: e => this.setEnrFilter({
        enrQ: e.target.value
      }),
      placeholder: "Search name or email",
      "aria-label": "Search people"
    })), /*#__PURE__*/React.createElement("div", {
      className: "ejl-people-list"
    }, !enrollments.length ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-people-empty"
    }, enrLoading ? "Loading…" : enrStatus || enrQ ? "No one matches." : running ? "No one has joined yet. New people are checked every 5 minutes." : "No one has joined this journey yet.") : enrollments.map(e => {
      const who = e.name || e.email || "Unknown contact";
      const when = e.status === "Active" ? e.lastSendDate || e.enrolledDate || e.createdDate : e.exitedDate || e.completedDate || e.modifiedDate || e.lastSendDate || e.enrolledDate || e.createdDate;
      return /*#__PURE__*/React.createElement("div", {
        key: e.id,
        className: "ejl-person",
        title: e.lastError ? String(e.lastError) : e.name && e.email ? e.email : undefined
      }, /*#__PURE__*/React.createElement("span", {
        className: "ejl-avatar",
        "aria-hidden": "true"
      }, initials(e.name, e.email)), /*#__PURE__*/React.createElement("div", {
        className: "ejl-person-main"
      }, /*#__PURE__*/React.createElement("b", null, who), /*#__PURE__*/React.createElement("span", null, this.personLine(e, graph, audiences))), /*#__PURE__*/React.createElement("span", {
        className: "ejl-person-date"
      }, shortDate(when)));
    })), enrMore ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ejl-seeall",
      disabled: enrLoading,
      onClick: () => this.loadEnrollments(true)
    }, enrLoading ? "Loading…" : enrCount != null ? `See all ${num(enrCount)}` : "See more") : null)));
  }
}
export default withRouter(EmailJourneyDetailViewComponent);